<template>
    <div class="materialReport">
        <!-- <el-button type="primary" @click="getPdf('#pdfdom')">下载报告</el-button> -->
        <div class="btns">
            <el-button type="primary" @click="createPage">下载报告</el-button>
            <el-button type="primary" @click="back">返回</el-button>
        </div>
        <div class="dingmei">
            <div class="tops" id="top">
                <div class="top">
                    <div class="l">
                        <span class="l-t">天信公估</span>
                        <span class="l-b">TIANXIN  ADJUSTERS</span>
                    </div>
                    <div class="r">
                        委托编号:
                        <span class="r-r">{{caseNo}}号</span>
                    </div>
                </div>
            </div>
        </div>
        
        <div id="pdfdom" class="pdf">
            <div class="title">评估委托书</div>
            
            <div class="p">
                <span style="width:100%">广州天信保险公估有限公司</span>
                <span class="span0">兹因</span><span class="span1"></span>
                <span>事宜需要，特委托贵公司对</span><span class="span1"></span>
                <span>所属的</span><span class="span1"></span>
                <span>于</span>
                <span class="span2">20 <div></div> 年 <div></div> 月 <div></div> 日</span>
                <span>发生车辆碰撞所产生的损失进行评估，为确保评估工作</span>客观、公正，委托方承诺如下，并承担相应的法律责任:
            </div>
            
            <div class="p">
                <span class="span0">1、评估目的指向的经济行为符合国家规定并获批准;</span>
            </div>
            <div class="p">
                <span class="span0">2、上述委估资产与评估目的相匹配;</span>
            </div>
            <div class="p">
                <span class="span0">3、纳入评估范围的车辆产权归属明确，提供给评估用的资料复印件与原件一致，原件合法有效，所陈述的情况真实、准确，出具的产权证明合法有效;</span>
            </div>
            <div class="p">
                <span class="span0">4、上述委估车辆(有/无)其他共有权人;</span>
            </div>
            <div class="p">
                <span class="span0">5、上述委估车辆未设定其他抵押、典当等他项权利，未拖欠建设工程款或购置款，不欠缴房产税，不存在法定优先受偿款;</span>
            </div>
            <div class="p">
                <span class="span0">6、上述委估车辆未被查封，不涉及任何诉讼;</span>
            </div>
            <div class="p">
                <span class="span0">7、不得干预评估工作的客观、公正。</span>
            </div>
            <div class="p">
                <span class="span0">8、评估费由双方约定按评估损失金额× <span style="width:28px;border-bottom:1px solid #000000;height:34px"></span>%收取。(最低收费500元)。</span>
            </div>
            <div class="p">
                <span class="span0">9、评估费在出具终期报告、发票后5个工作日内完成支付。</span>
            </div>
           

            <div class="wtf">
                委托方：(单位公章/个人签字)
            </div>
            <div class="date">
                <div>
                    <span></span>年<span></span>月<span></span>日
                </div>
            </div>
            
        </div>

        <div class="pages">
        </div>
        <div class="dingmeiimg"></div>

        <div class="backtop" @click="backTop">
            <i class="el-icon-top"></i>
        </div>
    </div>
</template>
<script>
import api from '../../../api/main'
import html2Canvas from 'html2canvas'
import store from '../../../store'

// import { provinceAndCityData , CodeToText } from "element-china-area-data";

export default {
    name: 'entrustMaterial',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            detail:{},
            page:1,
            htmlTitle:'价格评估委托准许书',
            scale:4,
            caseNo:'',
        }
    },
    created(){
        this.queryAssetsMaterialDamage();
    },
    mounted(){
        this.caseNo = this.$route.query.caseNo;
        
    },
    methods:{
        backTop(){
            document.querySelector('.el-main').scrollTop = 0

        },
        biaotou(){
            document.querySelector('.el-main').scrollTop = 0

            let _this = this;
            html2Canvas(document.getElementById('top'),{
                    backgroundColor: null, // 背景颜色
                    dpi: 192, // 将分辨率提高到特定的dpi,默认值为96
                    scale: this.scale, // 用于渲染的比例尺。默认为浏览器设备像素比率。默认值是1，手机端设置成2
                    useCORS:true, // 是否尝试使用CORS从服务器加载图像
                    scrollY: 0, 
                    scrollX: 0,
            }).then((canvas) => {
                _this.convertCanvasToImage(canvas);
            })
        },
        convertCanvasToImage(canvas) {
            // document.getElementById('top').remove();
            var imgStr = canvas.toDataURL("image/png");
            var img=new Image();
            img.src=imgStr;
            img.setAttribute('class', 'biaotou')
            document.querySelector('.dingmeiimg').append(img);
            this.getPdf('#pdfdom')
        },
        createPage(){
            this.page=1;
            store.dispatch('global/setLoading', true);
            var canvas = document.getElementById('pdfdom');
            var a4Width = 595.28;
            var a4Height = 701.89;
            var a4HeightRef = Math.floor((canvas.offsetWidth / a4Width) * a4Height)
            var p = canvas.offsetHeight/a4HeightRef;
            var pages = document.querySelector('.pages');
            for(let i = 0;i < p+1;i++){
                pages.innerHTML = pages.innerHTML + '<div class="page page'+this.page+'" style="width: 880px;font-size: 14px;text-align: center;">第'+this.page+'页</div>';
                this.pageToCanvas('page'+this.page);
                this.page = this.page+1;
            }

            this.biaotou();
        },
        pageToCanvas(page){
            console.log(page);
            let _this = this;
            html2Canvas(document.querySelector('.'+page),{
                    backgroundColor: null, // 背景颜色
                    dpi: 120, // 将分辨率提高到特定的dpi,默认值为96
                    scale: 1, // 用于渲染的比例尺。默认为浏览器设备像素比率。默认值是1，手机端设置成2
                    useCORS:true, // 是否尝试使用CORS从服务器加载图像
                    scrollY: 0, 
                    scrollX: 0,
            }).then((canvas) => {
                _this.pageCanvasToImage(canvas,page);
            })
        },
        pageCanvasToImage(canvas, className){
            var imgStr = canvas.toDataURL("image/png");
            var img=new Image();
            img.src=imgStr;
            img.setAttribute('class', 'img'+className)
            document.querySelector('.pages').append(img);
            // this.getPdf('#pdfdom')

        },
       
        async queryAssetsMaterialDamage(){
            
           
           
        },
        CNDateString(date){
            var cn = ["〇","一","二","三","四","五","六","七","八","九"];
            var s = [];
            var YY = date.getFullYear().toString();
            for (var i=0; i<YY.length; i++)
            if (cn[YY.charAt(i)])
            s.push(cn[YY.charAt(i)]);
            else
            s.push(YY.charAt(i));
            s.push("年");
            var MM = date.getMonth()+1;
            if (MM<10)
            s.push(cn[MM]);
            else if (MM<20)
            s.push("十" + cn[MM% 10]);
            s.push("月");
            var DD = date.getDate();
            if (DD<10)
            s.push(cn[DD]);
            else if (DD<20)
            s.push("十" + cn[DD% 10]);
            else if (DD<30)
            s.push("二十" + cn[DD% 10]);
            else
            s.push("三十" + cn[DD% 10]);
            s.push("日");
            return s.join('');
        },
        back(){
            this.$router.go(-1)
        },
        
       
        
    }
    
}
</script>

<style lang="scss" scoped>
   
    .materialReport{
        // font-family: 'simsun';
        background-color: #ffffff;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 20px;
        .dingmei{
            margin-top: 20px;
        }
        .backtop{
            box-shadow: 0 4px 4px rgba(0,21,41,.1);
            width: 60px;
            height: 60px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: fixed;
            right: 50px;
            bottom: 100px;
            font-size: 36px;
            background-color: rgba(0, 0, 0, 0.2);
            color: #ffffff;
            cursor: pointer;
        }
        .tops{
            padding: 0 100px;
            // .biaotou{
            //     width: 880px;
            // }
        }
        .top{
            width: 680px;
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #000000;
            .l{
                display: flex;
                flex-direction: column;
                .l-t{
                    font-size: 24px;
                }
                .l-b{
                    font-size: 16px;
                    margin-top: 4px;
                }
            }
            .r{
                font-size: 24px;
                span{
                    color: red;
                    font-size: 18px;
                    text-decoration: underline;
                }
            }
        }
        .pdf{
            // border: 1px solid #000000;
            width: 680px;
            padding: 0 100px;
            padding-top: 15px;
            .title{
                font-size: 36px;
                font-weight: bold;
                text-align: center;
                letter-spacing: 2px;
                line-height: 70px;
            }
            .p{ 
                display: flex;
                flex-wrap: wrap;
                font-size: 20px;
                line-height: 45px;
                .span0{
                    text-indent: 2em;
                    display: flex;
                    flex-wrap: wrap;
                }
                .span1{
                    width: 92px;
                    height: 34px;
                    border-bottom: 1px solid #000000;
                }
                .span2{
                    width: 196px;
                    height: 24px;
                    border-bottom: 1px solid #000000;
                    display: flex;
                    align-items: center;
                    padding-top: 10px;
                    div{
                        width: 40px;
                    }
                }
                
            }
            
            .wtf{
                font-size: 22px;
                text-align: right;
                margin-top: 80px;
                padding-right: 30px;
            }
            .date{
                display: flex;
                font-size: 22px;
                flex-direction: row-reverse;
                margin-top: 20px;
                padding-right: 110px;
                div{
                    display: flex;
                    span{
                        display: block;
                        width: 30px;
                    }
                }
            }
        }
        
    }
    .pages{
        width: 880px;
        .page{
            width: 880px;font-size: 14px;text-align: center;
            display: flex;
            justify-content: center;
        }
    }
</style>
